import { useEffect } from 'react'
import { checkCurrentVersionResponseSchema } from '@mobi/api-types'
import { sendToNative } from '@mobi/web-native-comms/web'
import { fullClientVersion } from '../clientVersion'
import { useFeature } from './useFeature'
import { FeatureFlags } from '@mobi/settings'

let lastQueryTime = Date.now()

const ONE_HOUR_IN_MS = 1000 * 60 * 60

// triggered when the home page is loaded
export function useRefreshOnVersionUpgrade() {
  const autoRefreshEnabled = useFeature(FeatureFlags.AUTO_REFRESH_ON_VERSION_CHANGE.key)

  useEffect(() => {
    if (autoRefreshEnabled && lastQueryTime + ONE_HOUR_IN_MS < Date.now()) {
      lastQueryTime = Date.now()

      fetch(
        `/api/support/webapp/check-current-version?clientVersion=${encodeURIComponent(fullClientVersion)}`
      )
        .then(response => response.json())
        .then(json => {
          const result = checkCurrentVersionResponseSchema.safeParse(json)

          if (result.success) {
            const { data } = result

            if ('shouldClientReload' in data && data.shouldClientReload) {
              logToTabTouchClientLog('refreshOnVersionUpgrade', {
                fromVersion: data.clientVersion,
                toVersion: data.defaultClientVersion,
              })

              resolveAfterDelay(150).then(() => {
                location.reload()
              })
            }
          }
        })
    }
  }, [autoRefreshEnabled])
}

function logToTabTouchClientLog(eventKey: string, data?: Record<string, string>) {
  sendToNative('GOOGLE_ANALYTICS_WEBVIEW_EVENT', {
    eventKey,
    data,
  })
}

function resolveAfterDelay(timeInMs: number) {
  return new Promise<void>(resolve => {
    setTimeout(() => resolve(), timeInMs)
  })
}
